import { styled } from "@mui/material/styles";
import { useColors } from "../../Context/ColorsContext"
import { CardContent, CardHeader, Typography, Icon, Grid, Pagination } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import TimelineDot from '@mui/lab/TimelineDot';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import { MediaQuerys } from "../../styles/GlobalStyle";

const { tablet, desktop } = MediaQuerys

export const Container = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    height: '820px',
    '&::-webkit-scrollbar': {
        width: '4px',
    },
    [tablet]: {
        height: '100%',
        marginTop: 0,
    }
}))

export const Header = styled(CardHeader)(() => {
    const { colors } = useColors();
    return {
        color: colors.main,
        padding: 8,
        textAlign: 'center',
        '.MuiTypography-root': {
            fontSize: 11,
            textTransform: 'uppercase',
            fontWeigth: 'bold'
        }
    }
})

export const ContentSearch = styled(CardContent)(() => {
    const { colors } = useColors();
    return {
        background: colors.background,
        padding: '2px 10px'
    }
})

export const Content = styled(CardContent)(({theme}) => {
    const { colors } = useColors();

    return {
        '&::-webkit-scrollbar': {
            width: '4px',
            height: '4px',
        },
        padding: '16px',
        overflowY: 'auto',
        flexGrow: 1,
        maxHeight: '90%',
        flex: 1,
        overflow: 'auto',
        [tablet]: {
            maxHeight: '415px',
        },
    }
})

export const PaginationContainer = styled('div')(() => {
    return {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '6px 16px',
        borderTop: '1px solid #e0e0e0',
        backgroundColor: '#fff',
        minHeight: '36px',
		marginTop: 'auto',
        flexWrap: 'wrap',
        gap: 4,
        [tablet]: {
            justifyContent: 'flex-end',
            flexDirection: 'row'
        },
        [desktop]: {
            flexDirection: 'row',
            justifyContent: 'flex-end',
        }
    }
})

export const CustomPagination = styled(Pagination)(() => {
    return {
        '& .MuiPaginationItem-root': {
            fontSize: '11px',
            height: '24px',
            minWidth: '24px',
            color: '#8e8e8e',
            '&.Mui-disabled': {
                color: '#dddddd',
                opacity: 1,
            },
            '&.Mui-selected': {
                color: '#535353',
                backgroundColor: '#ececec',
                '&:hover': {
                    backgroundColor: '#e0e0e0',
                }
            }
        }
    }
})

// export const CustomTimeLine = styled(Timeline)(() => ({
//     padding: 0,
//     margin: 0,
//     '.MuiTimelineItem-root': {
//         minHeight: '50px'
//     },
//     '.MuiTimelineOppositeContent-root': {
//         padding: '4px 10px'
//     }
// }))

export const TypoTimeLine = styled(Typography)(({ type }) => {
    const { colors } = useColors();
    return {
        // color: type === 'title' ? colors.detailTextColor : colors.grayFont,
        color: colors.grayFont,
        fontSize: 11,
        fontWeight: type === 'title' ? 'bold' : 'normal',
        // lineHeight: 1.2
    }
})

export const Search = styled(SearchIcon)(() => {
    const { colors } = useColors();
    return {
        width: 20,
        height: 20,
        cursor: 'pointer',
        color: colors.grayFont
    }
})

// export const IconArea = styled('div')(() => {
//     const { colors } = useColors();
//     return {
//         marginLeft: 2,
//         width: 15,
//         height: 15,
//         fontSize: 11,
//         fontWeight: 'bold',
//         color: colors.white,
//         background: colors.orange,
//         borderRadius: 20,
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center'
//     }
// })

export const Title = styled(Typography)(() => {
    const { colors } = useColors();
    return {
        color: '#1b1a1b',
        fontWeight: 'bold',
        [desktop]: {
            fontSize: '1rem',
        }
    }
})

export const CustomIcon = styled(Icon)(() => {
    const { colors } = useColors();
    return {
        color: colors.white,
        fontSize: 20,
        [desktop]: {
            fontSize: '15px',
        }
    }
})


export const CustomTitle = styled('span')(({ type }) => {
    const { colors } = useColors();
    return {
        // color: type === 'title' ? colors.detailTextColor : colors.grayFont,
        color: colors.grayFont,
        fontSize: 11,
        marginLeft: type !== 'title' && '3px',
        fontWeight: type === 'title' ? 'bold' : 'normal',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'block',
        maxWidth: '100%',
        [desktop]: {
            marginLeft: 0,
            fontSize: 10,
        }
        // lineHeight: 1.2
    }
})

export const GroupItems = styled('div')(() => {
    return {
        display: 'flex',
    }
})

export const IconArea = styled('div')(() => {
    const { colors } = useColors();
    return {
        width: 15,
        height: 15,
        fontSize: 10,
        fontWeight: 'bold',
        color: '#6c93c0',
        background: '#daecff',
        borderRadius: 20,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // margin: 'auto',
        [desktop]: {
            height: 15,
            width: 15
        }
    }
})


export const ContainerGroup = styled('span')(() => {
    return {
        display: 'flex',
        width: 'auto',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'row',
        gap: '3px'
    }
})

export const CustomGrid = styled('div')(({ fixWidth }) => {
    return {
        display: 'flex',
        minWidth: 0,
        width: fixWidth && 'inherit',
        [desktop]: {
            flexDirection: 'column',
        }

    }
})

export const CustomTimelineDot = styled(TimelineDot)(() => {
    return {
        justifyContent: 'center',
        alignItems: 'center',
        width: '32px',
        [desktop]: {
            width: '25px',
            height: '25px'
        }
    }
})

export const CustomTimeLine = styled(Timeline)(() => {
    return {
        display: 'flex',
        padding: 0,
        flexDirection: 'column',
        gap: '0.50rem',
    }
})


export const ContainerLeft = styled('div')(() => {
    return {
        width: '25%',
        flex: '0 0 25%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
        flexDirection: 'column',
        marginRight: '7px',
    }
})


export const ContainerCenter = styled('div')(() => {
    return {
        width: '15%',
        // display: 'flex',
        // flexDirection: 'c',
    }
})


export const ContainerRight = styled('div')(() => {
    return {
        width: '65%',
        flex: '1 1 65%',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        marginLeft: '7px',
        minWidth: 0,
        // [desktop]: {

        // }
    }
})

export const CustomTimeLineItem = styled(TimelineItem)(() => {
    return {
        justifyContent: 'flex-start',
        // gap: '0.70rem',
        '&::before': {
            content: 'none',
        },
        // [desktop]: {
        //     gap: '0.50rem',
        // }
    }
})

export const InstaTimeContent = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        backgroundColor: '#f1f5f9',
        padding: '6px 10px',
        width: '100%',
        boxSizing: 'border-box',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: '0px',
    }
})

export const ContainerGrid = styled(Grid)(() => {
    return {
        alignItems: 'center',
        justifyContent: 'flex-start',
        flexDirection: 'row',
        gap: '3px',
        minWidth: 0,
        [tablet]: {
            alignItems: 'center',
        }
    }
})
